<template>
  <div class="my-movie-page">
    <!-- 导航栏 -->
    <div class="custom-nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-left" @click="back">
          <i class="nav-bar-arrow van-icon van-icon-arrow-left"></i>
        </div>
        <div class="nav-bar-title">
          {{$t('myMovie')}}
        </div>
      </div>
    </div>
    
    <!-- 主要内容 -->
    <div class="main-content" ref="mainContent">
      <!-- 用户信息卡片 -->
      <div class="user-card">
        <div class="user-info">
          <div class="avatar-section">
            <div class="avatar-container">
              <img :src="avatarUrl" class="avatar-img" alt="User Avatar">
            </div>
            <div class="user-details">
              <h1 class="username">Hi, {{userInfo.username}}</h1>
              <p class="user-tips">{{$t('completeTaskForMore')}}</p>
            </div>
          </div>
          <div class="ticket-count">
            {{$t('movieTicket')}}{{userInfo.video_money}}
          </div>
        </div>
      </div>

      <!-- 观看记录区域 -->
      <div class="watch-section">
        <div class="section-header">
          <button :class="['record-tab', {active: activeRecord === 'watch'}]" @click="activeRecord = 'watch'">
            <van-icon name="play-circle-o" /> Watch history
          </button>
          <button :class="['record-tab', {active: activeRecord === 'ticket'}]" @click="activeRecord = 'ticket'">
            <van-icon name="coupon-o" /> Ticket history
          </button>
        </div>
        
        <van-pull-refresh v-if="activeRecord === 'watch'" v-model="refreshing" @refresh="onRefresh">
          <!-- 观看记录列表 -->
          <div v-if="watchHistory.length > 0" class="watch-history-list">
            <div 
              v-for="(item, index) in watchHistory" 
              :key="`${item.id}_${index}`" 
              class="history-item"
              @click="playVideo(item)"
            >
              <div class="video-thumbnail">
                <img :src="item.video_pic" :alt="item.video_name" class="thumbnail-img">
                <div class="play-overlay">
                  <i class="play-icon van-icon van-icon-play"></i>
                </div>
              </div>
              <div class="video-info">
                <h3 class="video-title">{{ item.video_name }}</h3>
                <p class="video-meta">
                  <span class="category">{{ item.video_class_name }}</span>
                  <span class="duration">{{ item.video_duration }}</span>
                </p>
                <p class="watch-time">Watched: {{ formatTime(item.watch_time) }}</p>
              </div>
              <div class="video-actions">
                <van-icon name="delete" @click.stop="deleteHistory(item.id)" />
              </div>
            </div>
          </div>
          
          <!-- 空状态 -->
          <div v-else class="empty-state">
            <div class="van-empty">
              <div class="van-empty__image">
                <img src="/img/z35.png" alt="No data">
              </div>
              <p class="van-empty__description">
                {{$t('noDataYet')}}
              </p>
            </div>
          </div>
        </van-pull-refresh>

        <van-pull-refresh v-else v-model="ticketRefreshing" @refresh="onTicketRefresh">
          <div v-if="ticketHistory.length" class="ticket-history-list">
            <div v-for="(item,index) in ticketHistory" :key="`${item.id || item.expect}_${index}`" class="ticket-item">
              <div class="ticket-mark"><van-icon name="coupon-o" /></div>
              <div class="ticket-info">
                <h3>{{item.name}}</h3>
                <p>Issue: {{item.expect}}</p>
                <p class="ticket-types">{{item.content}}</p>
                <time>{{item.create_time || '--'}}</time>
              </div>
              <div class="ticket-amount">{{item.money}}<small>Points</small></div>
            </div>
          </div>
          <div v-else class="empty-state">
            <van-empty :description="$t('noDataYet')" />
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {},
      watchHistory: [],
      ticketHistory: [],
      activeRecord: 'watch',
      ticketRefreshing: false,
      loading: false,
      finished: false,
      page: 1,
      limit: 20,
      refreshing: false,
      avatarUrl: '/img/the-weks-selective.svg?v=2',
      watchIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFRUlEQVRYhZ2YW6hdVxWGv29nW2pytBg9PhSt4osoQitFsGAstqgVC2qjiVBBTUtBgqBUCEVQfFBBqRp88vbgQ0GxtehDEyJNTrw0pUJJqQWxVXxRS3LUVmnEmLN+H9bca8912SdHYR/OmnuOOS7/+MeYY21//tFjmCAgKc9BuEZyO8nNwh7JL00eFn4muQDBlDOtPCzPYgILneU/lR0mZCDMG2ZoURRQkbxHcr9xN8u9t6qflJw3PCCeijkpbBpbGSWLoFo9BIrjVPtlr8iUTytz8mMnuohKtG8UnirrZyE/NGxK3ix5t2FPhcolkgckPxZOmZzvou/Q7iPS36e3Bpg3znoRSb5e1r+R7CN5rkVQTPZq9os3S24yWUcOigdNtpQfiA9LTiT8qdPZIcJCT+uCi/RWCJ34+MmaB2sm/2y9zTsMG93emGcvEm6BHDC5Sbh6IHesoHta8sc+z5b8I30OefzQBpXR/ZL7gb+ZvHz5fUXeHpFrhXmT4QOS/ZJrl8QOkjMt7/Kg8AdG6az0PnTH6VrxMcktJg8Kt0nmDiqnrqpisBGaak/DPsntkn3AGwY6zkjuAzYkTy0co+zPtzoO5WrxxvL8TsnzxqoCezzr1l20LT8akxc058WLkqvMsprKmRskN0hIfFLzI8lR4z9C8Cd3/grJPslxk90T/Wi8XqZikM4+P5ZVNMVBah1/lXxQsjFvnO2VnDC5UrMp+bT4uw7+RZW44EyFVItmVzlLNBd9aUFk+3vt85b4iiT3aN4unjJ53bzRI8KV4p9bMmazTg/bGZ1KZy2/8jyV0xwPbpjcqHxt3jh7bxG8T9zkfzJKXwY6RxYpo8+fVU4fUR+V3DrfYrZeFD638tAqJ7u/8ZnVgUG/OATzTNmbzxu9VIxeUSnYo7lK0oyqq0ZiwihjNNRsied68tV54IrF+XnjLEVBisFPSL4irknSQ6HnQAbpWImmki2T4+qtw7ZRUjZbnG/vsr7RazRrRaHbO7BDcie7NNePkRmfr8cPi8J7JA+ZrGFymeraNYlMTey2LTaSx5aOtvf7VHHMGx0pJP5iB1EPyD3u4sOKZAdo9saPQsi3aQ6Lu02aFVHPhAviVyWPTzk6lY6d9LM6ZaEtybskH67up20iytPGx1dU1woHVsiUYEvKgCWBP2N8QvPiulcM+wjkXybf//+6+AjxmkOzUkGd4nOae6ea3VJuh9U11bumy77iEC4H8tGIQc/QZfvOiqh33sVT9aG2hS8dwdEhJpycmpG2d2B7nrUc6ryE9O4qVyvuoTHmED0HVl81QyerKqs5Ml1Z1IoZRsrAaVYanexdZT2P7Y3VGmiVZjHddQa7yppIU9/oJM+GTlymD6lp+3Mn3A6XLRJ9LmWcznXh88Z1zCO28zGa2yQHJf8xfkHztOSlJp9TX237av5vuZ62ag7tKvBezCAN3XBewU9/2kN8v8nhds8DJkdLyr4j7i2GnhcPm7xLc3e5ng5ovin5t8nFjkPBF9Ki8MqW1PTSlV7FWRzt8eyn6rrkVSS/rNL5IZP3qRck3y2pPgk5YvIazRnxYnH4uoL6ll+6+y/fEw6R/F14i+T33RtB/Xaw3S8dI9nq+8HZ3pvrUsdZybUmj8zD7Fshh9SXQc4Gvmg4K1yKdm8dWH7J6Lgj6RM70n6q1pAyMTK47RvjTPNayZ2tM6L57LzRx4RPJXxDWBO/nDo97Zze8ajPs0L+QZlnzLPh9dSvwHaq+Ii4MS++H0V+C9yV8HrhJaVHdr2lNjzm2cL4Sp4NrycljeSc4bT6bckzJvwXm3g8AV5f3OgAAAAASUVORK5CYII='
    };
  },
  mounted() {
    this.getUserInfo();
    this.getWatchHistory();
    this.getTicketHistory();
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    // 获取用户信息
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).catch(error => {
        console.error('获取用户信息失败:', error);
        this.$toast(this.$t('common.networkError'));
      });
    },
    
    // 获取观看历史
    getWatchHistory() {
      this.loading = true;
      this.$http({
        method: 'get',
        data: {
          page: this.page,
          limit: this.limit
        },
        url: 'video_watch_history'
      }).then(res => {
        this.loading = false;
        this.refreshing = false;
        
        if (res.code === 200) {
          const payload = res.data || {};
          let rows = Array.isArray(payload) ? payload : (payload.data || payload.list || []);
          if (!Array.isArray(rows) && rows && typeof rows === 'object') rows = Object.values(rows);
          rows = rows.map(this.normalizeWatchItem);
          if (this.page === 1) {
            this.watchHistory = rows;
          } else {
            this.watchHistory = [...this.watchHistory, ...rows];
          }
          
          if (rows.length < this.limit) {
            this.finished = true;
          }
        } else if (Number(res.code) === 404) {
          this.watchHistory = [];
          this.finished = true;
          console.warn('当前 API 暂未提供观看记录接口');
        } else {
          this.$toast(res.msg || this.$t('noDataYet'));
        }
      }).catch(error => {
        console.error('获取观看历史失败:', error);
        this.loading = false;
        this.refreshing = false;
        this.$toast(this.$t('common.networkError'));
      });
    },
    normalizeWatchItem(item) {
      return {
        ...item,
        id: item.id || item.history_id || item.video_id,
        video_id: item.video_id || item.api_vod_id || item.id,
        video_name: item.video_name || item.vod_name || item.title || '--',
        video_pic: item.video_pic || item.vod_pic || item.pic || item.cover || '/img/z35.png',
        video_url: item.video_url || item.vod_play_url || item.url || '',
        video_class_name: item.video_class_name || item.class_name || item.category || '',
        video_duration: item.video_duration || item.vod_duration || item.duration || '',
        watch_time: item.watch_time || item.update_time || item.create_time || ''
      };
    },
    getTicketHistory() {
      this.$http({
        method: 'get',
        data: {page: 1, pageSize: 50, limit: 50, status: 0, lottery_id: 'all'},
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code !== 200) return;
        const payload = res.data || {};
        let rows = Array.isArray(payload) ? payload : (payload.list || payload.data || []);
        if (!Array.isArray(rows) && rows && typeof rows === 'object') rows = Object.values(rows);
        this.ticketHistory = rows.map(item => ({
          ...item,
          name: item.name || (item.lottery && item.lottery.name) || this.$t('game.workRecord'),
          expect: item.expect || item.issue || '--',
          money: item.money !== undefined ? item.money : (item.amount || '0.00'),
          create_time: item.create_time || item.created_at || '',
          content: (Array.isArray(item.data) ? item.data : []).map(v => this.getTicketType(v.type)).join(', ') || '--'
        }));
      }).finally(() => { this.ticketRefreshing = false; });
    },
    getTicketType(type) {
      if (!type) return '';
      const key = 'game.' + type;
      return this.$te && this.$te(key) ? this.$t(key) : String(type);
    },
    onTicketRefresh() {
      this.getTicketHistory();
    },
    
    // 播放视频
    playVideo(item) {
      const videoId = item.db_video_id || item.video_id;
      console.log('播放视频:', { 
        db_video_id: item.db_video_id, 
        api_video_id: item.video_id, 
        using_id: videoId 
      });
      
      this.$router.push({
        path: '/PlayVideo',
        query: {
          id: videoId,
          url: item.video_url,
          title: item.video_name,
          pic: item.video_pic
        }
      });
    },
    
    // 删除观看记录
    deleteHistory(historyId) {
      this.$dialog.confirm({
        title: 'Confirm deletion',
        message: this.$t('common.confirmDeleteHistory')
      }).then(() => {
        this.$http({
          method: 'post',
          data: {
            id: historyId
          },
          url: 'video_delete_watch'
        }).then(res => {
          if (res.code === 200) {
            this.$toast(this.$t('common.deleteSuccess'));
            this.page = 1;
            this.finished = false;
            this.getWatchHistory();
          } else {
            this.$toast(res.msg || this.$t('common.deleteFailed'));
          }
        }).catch(error => {
          console.error('删除观看记录失败:', error);
          this.$toast(this.$t('common.deleteFailed'));
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return 'Unknown time';

      const numeric = Number(timestamp);
      const date = Number.isFinite(numeric)
        ? new Date(numeric < 1000000000000 ? numeric * 1000 : numeric)
        : new Date(String(timestamp).replace(/-/g, '/'));
      if (Number.isNaN(date.getTime())) return String(timestamp);
      const now = new Date();
      const diff = now - date;
      
      if (diff < 60000) {
        return 'Just now';
      } else if (diff < 3600000) {
        return Math.floor(diff / 60000) + ' minutes ago';
      } else if (diff < 86400000) {
        return Math.floor(diff / 3600000) + ' hours ago';
      } else if (diff < 604800000) {
        return Math.floor(diff / 86400000) + ' days ago';
      } else {
        return date.toLocaleDateString();
      }
    },
    
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.getWatchHistory();
      setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false;
          this.$toast(this.$t('common.refreshSuccess'));
        }
      }, 2000);
    },
    
    // 安全的滚动位置获取方法
    getScrollTop() {
      const element = this.$refs.mainContent;
      if (element && element.scrollTop !== undefined) {
        return element.scrollTop;
      }
      return 0;
    },
    
    // 安全的滚动位置设置方法
    setScrollTop(top) {
      const element = this.$refs.mainContent;
      if (element && element.scrollTop !== undefined) {
        element.scrollTop = top;
      }
    }
  },
  beforeDestroy() {
    // 清理工作
    this.refreshing = false;
    this.loading = false;
  }
};
</script>

<style lang="less" scoped>
.my-movie-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

/* 导航栏样式 */
.custom-nav-bar {
  height: 3.5rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  z-index: 10;
}

.nav-bar-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.nav-bar-left {
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    background: rgba(255, 255, 255, 0.2);
  }
}

.nav-bar-arrow {
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
}

.nav-bar-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

/* 主要内容区域 */
.main-content {
  padding: 1rem;
  background: #f5f5f5;
  min-height: calc(100vh - 3.5rem);
}

/* 用户信息卡片 */
.user-card {
  background: white;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.avatar-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #f0f2ff;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.username {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.user-tips {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
}

.ticket-count {
  background: linear-gradient(135deg, #3498db, #8e44ad);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
}

/* 观看记录区域 */
.watch-section {
  background: white;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-header {
  padding-bottom: 1rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f2f2f5;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.section-icon {
  width: 20px;
  height: 20px;
}

/* 观看记录列表 */
.watch-history-list {
  padding: 0;
}

.history-item {
  display: flex;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 0.8rem;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  
  &:active {
    border-color: #667eea;
    background: #f8f9ff;
    transform: translateY(1px);
  }
}

.video-thumbnail {
  position: relative;
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(102, 126, 234, 0.8);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-icon {
  color: #fff;
  font-size: 16px;
  margin-left: 2px;
}

.video-info {
  flex: 1;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.video-title {
  font-size: 0.95rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-meta {
  margin: 0 0 8px 0;
  font-size: 0.8rem;
  color: #666;
}

.category {
  background: #f0f2ff;
  color: #667eea;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 0.75rem;
}

.duration {
  color: #999;
  font-size: 0.75rem;
}

.watch-time {
  margin: 0;
  font-size: 0.75rem;
  color: #999;
}

.video-actions {
  display: flex;
  align-items: flex-start;
  margin-left: 8px;
}

.video-actions .van-icon {
  color: #ff6b6b;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s;
  
  &:active {
    background: rgba(255, 107, 107, 0.1);
    transform: scale(0.9);
  }
}

/* 空状态 */
.empty-state {
  padding: 2rem 1rem;
  text-align: center;
}

::v-deep .van-empty__image {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

::v-deep .van-empty__description {
  color: #969799;
  font-size: 0.9rem;
}

/* 响应式调整 */
@media (max-width: 320px) {
  .main-content {
    padding: 0.8rem;
  }
  
  .user-card,
  .watch-section {
    padding: 1rem;
  }
  
  .history-item {
    padding: 0.8rem;
  }
  
  .video-thumbnail {
    width: 100px;
    height: 75px;
  }
  
  .video-title {
    font-size: 0.9rem;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from { 
    opacity: 0; 
    transform: translateY(15px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.history-item {
  animation: fadeInUp 0.4s ease forwards;
}

.history-item:nth-child(odd) {
  animation-delay: 0.1s;
}

.history-item:nth-child(even) {
  animation-delay: 0.2s;
}

/* 我的电影：黑金会员影库 */
.my-movie-page {
  min-height: 100vh;
  color: #f3eadb;
  background: linear-gradient(rgba(3,5,8,.82),rgba(3,5,8,.97)), url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed no-repeat;
}

.custom-nav-bar {
  height: 4.4rem;
  border-bottom: 1px solid rgba(218,180,105,.42);
  background: rgba(4,6,9,.97) !important;
  box-shadow: 0 .6rem 1.6rem rgba(0,0,0,.4);
}

.nav-bar-left {
  min-width: 3.5rem;
  min-height: 3.5rem;
  display: flex;
  align-items: center;
}

.nav-bar-arrow {
  color: #efd18a;
  font-size: 1.65rem;
}

.nav-bar-title {
  color: #efd18a;
  font-size: 1.18rem;
  font-weight: 750;
}

.main-content {
  padding: .9rem .8rem 2rem;
  min-height: calc(100vh - 4.4rem);
  background: transparent;
}

.user-card,
.watch-section {
  border: 1px solid rgba(218,180,105,.34);
  border-radius: 1.2rem;
  background: linear-gradient(145deg,rgba(15,18,23,.96),rgba(6,8,12,.98));
  box-shadow: 0 .9rem 2.2rem rgba(0,0,0,.4), inset 0 1px 0 rgba(255,255,255,.04);
}

.user-card {
  padding: 1rem;
  margin-bottom: .9rem;
}

.avatar-container {
  width: 3.8rem;
  height: 3.8rem;
  border: 1px solid #d9b66e;
  box-shadow: 0 0 0 .25rem rgba(218,180,105,.08);
  background: #0a0d11;
}

.username {
  color: #ecd08c;
  font-size: 1.05rem;
  font-weight: 700;
}

.user-tips {
  color: #aaa08f;
  font-size: .8rem;
}

.ticket-count {
  padding: .65rem 1rem;
  color: #171006;
  font-size: .84rem;
  font-weight: 750;
  border: 1px solid rgba(247,220,160,.66);
  background: linear-gradient(110deg,#a97732,#e7c87c,#bb853c);
  box-shadow: 0 .6rem 1.35rem rgba(185,130,48,.25);
}

.watch-section {
  min-height: 19rem;
  padding: 1rem;
}

.section-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: .65rem;
  border-bottom-color: rgba(218,180,105,.2);
}

.record-tab {
  min-height: 2.75rem;
  color: #a99d89;
  font-size: .95rem;
  font-weight: 650;
  border: 1px solid rgba(218,180,105,.25);
  border-radius: .75rem;
  background: rgba(5,8,12,.75);
}

.record-tab .van-icon {
  margin-right: .3rem;
  font-size: 1.05rem;
}

.record-tab.active {
  color: #171006;
  border-color: rgba(247,220,160,.75);
  background: linear-gradient(110deg,#a97732,#e7c87c,#bb853c);
  box-shadow: 0 .5rem 1.1rem rgba(185,130,48,.2);
}

.section-title {
  color: #e8c980;
  font-size: 1rem;
}

.section-icon {
  filter: sepia(1) saturate(.65) brightness(1.25);
}

.history-item {
  padding: .8rem;
  border: 1px solid rgba(218,180,105,.28);
  border-radius: .9rem;
  background: rgba(10,13,18,.92);
  box-shadow: 0 .6rem 1.4rem rgba(0,0,0,.28);
}

.history-item:active {
  border-color: #e3c27a;
  background: rgba(216,177,99,.08);
}

.video-thumbnail {
  border: 1px solid rgba(218,180,105,.28);
  border-radius: .7rem;
}

.play-overlay {
  color: #171006;
  border: 1px solid rgba(247,220,160,.66);
  background: linear-gradient(135deg,#a97732,#e7c87c);
}

.play-icon {
  color: #171006;
}

.video-title {
  color: #ead09a;
  font-size: .92rem;
}

.video-meta,
.watch-time,
.duration {
  color: #9f9586;
}

.category {
  color: #dfbd78;
  border: 1px solid rgba(218,180,105,.35);
  background: rgba(216,177,99,.08);
}

.video-actions .van-icon {
  color: #d6a963;
}

.empty-state {
  padding: 3rem 1rem;
}

.empty-state .van-empty__image {
  opacity: .52;
  filter: sepia(1) saturate(.45) brightness(.9);
}

.empty-state .van-empty__description {
  color: #a99e8c !important;
  font-size: .88rem;
}

.ticket-history-list {
  display: grid;
  gap: .8rem;
}

.ticket-item {
  display: grid;
  grid-template-columns: 3rem minmax(0, 1fr) auto;
  align-items: center;
  gap: .8rem;
  padding: .9rem;
  border: 1px solid rgba(218,180,105,.3);
  border-radius: .9rem;
  background: rgba(8,11,16,.94);
  box-shadow: 0 .55rem 1.3rem rgba(0,0,0,.25);
}

.ticket-mark {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #171006;
  font-size: 1.45rem;
  border-radius: 50%;
  background: linear-gradient(135deg,#a97732,#e7c87c);
}

.ticket-info {
  min-width: 0;
}

.ticket-info h3 {
  margin: 0 0 .28rem;
  color: #efd18a;
  font-size: 1rem;
}

.ticket-info p,
.ticket-info time {
  display: block;
  margin: .12rem 0;
  color: #a99f90;
  font-size: .75rem;
  overflow-wrap: anywhere;
}

.ticket-info .ticket-types {
  color: #cfb77e;
}

.ticket-amount {
  color: #f0cb6d;
  font-size: 1.05rem;
  font-weight: 800;
  text-align: right;
}

.ticket-amount small {
  display: block;
  margin-top: .2rem;
  color: #a89d8a;
  font-size: .66rem;
  font-weight: 500;
}

@media (max-width: 430px) {
  .my-movie-page {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    background-attachment: scroll;
  }

  .custom-nav-bar {
    height: auto;
    min-height: 60px;
    padding-top: env(safe-area-inset-top);
  }

  .nav-bar-content {
    min-height: 60px;
    padding: 0 10px;
  }

  .nav-bar-title {
    min-width: 0;
    padding-right: 44px;
    font-size: 17px;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }

  .main-content {
    min-width: 0;
    padding: 12px 10px max(24px, env(safe-area-inset-bottom));
  }

  .user-card,
  .watch-section {
    min-width: 0;
    padding: 14px 12px;
    border-radius: 18px;
  }

  .user-info,
  .avatar-section,
  .user-details {
    min-width: 0;
  }

  .user-info {
    gap: 10px;
  }

  .avatar-section {
    flex: 1 1 auto;
    gap: 10px;
  }

  .user-details {
    flex: 1;
  }

  .username,
  .user-tips,
  .ticket-count {
    max-width: 100%;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .username {
    font-size: 16px;
  }

  .ticket-count {
    flex: 0 1 auto;
    padding: 8px 10px;
    font-size: 12px;
    text-align: center;
    white-space: normal;
  }

  .section-header {
    gap: 8px;
  }

  .record-tab {
    min-width: 0;
    min-height: 48px;
    padding: 8px 6px;
    font-size: 14px;
    line-height: 1.3;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .history-item,
  .video-info,
  .video-meta {
    min-width: 0;
  }

  .history-item {
    gap: 0;
    padding: 11px;
  }

  .video-thumbnail {
    width: clamp(78px, 27vw, 104px);
    height: clamp(59px, 20.25vw, 78px);
  }

  .video-info {
    margin-left: 10px;
  }

  .video-title,
  .video-meta,
  .watch-time {
    overflow-wrap: anywhere;
  }

  .video-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 6px;
  }

  .category {
    margin-right: 0;
  }

  .video-actions {
    flex: 0 0 auto;
    margin-left: 4px;
  }

  .ticket-item,
  .ticket-info,
  .ticket-amount {
    min-width: 0;
  }

  .ticket-item {
    grid-template-columns: 42px minmax(0, 1fr) auto;
    gap: 9px;
    padding: 12px 10px;
  }

  .ticket-mark {
    width: 42px;
    height: 42px;
  }

  .ticket-info h3,
  .ticket-amount {
    overflow-wrap: anywhere;
  }
}

@media (max-width: 360px) {
  .user-info {
    align-items: flex-start;
    flex-direction: column;
  }

  .ticket-count {
    align-self: stretch;
  }

  .ticket-item {
    grid-template-columns: 42px minmax(0, 1fr);
  }

  .ticket-amount {
    grid-column: 2;
    text-align: left;
  }
}
</style>
